export const selectGetIsFetching = state => state.auth.isFetching;
export const selectGetMe = state => state.auth.me;
export const selectGetUID = state => state.auth.me.uid;
export const selectGetEmail = state => state.auth.me.email;
export const selectIsUserLogged = state => !!state.auth.me.uid;
